module.exports = __webpack_public_path__ + "bd5b1ed8e4b7ec1d7cb1367785191184.MP3";